<template>
  <div class="mapa-calor-tif">
    <Loading v-if="cargando" />

    <!-- Filtros -->
    <div class="card shadow-sm border-0 mb-3">
      <div class="card-header bg-white border-0">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <span class="badge bg-light text-dark border rounded-pill me-2">
              <i class="fas fa-filter me-1"></i>
              Filtros
            </span>
            <small class="text-muted">Rango, operación y tipo de novedad</small>
          </div>
          <span class="badge bg-white text-dark border rounded-pill">
            {{ filtros.fecha_inicial }} → {{ filtros.fecha_final }}
          </span>
        </div>
      </div>
      <div class="card-body">
        <div class="row g-3">
          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1"
              >Fecha inicial</label
            >
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white">
                <i class="fas fa-calendar-alt text-muted"></i>
              </span>
              <input
                v-model="filtros.fecha_inicial"
                type="date"
                class="form-control"
                :max="filtros.fecha_final"
              />
            </div>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1">Fecha final</label>
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-white">
                <i class="fas fa-calendar-alt text-muted"></i>
              </span>
              <input
                v-model="filtros.fecha_final"
                type="date"
                class="form-control"
                :min="filtros.fecha_inicial"
                :max="hoy"
              />
            </div>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1"
              >Tipo de servicio</label
            >
            <select
              v-model="filtros.tipo_servicio"
              class="form-select form-control form-control-sm"
            >
              <option :value="null">Todos</option>
              <option :value="1">Tep Viajes</option>
              <option :value="2">Tif Turno</option>
              <option :value="3">Tep Turno</option>
              <option :value="4">Planta Externa Viajes</option>
            </select>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1"
              >Tipo de novedad</label
            >
            <select
              v-model="filtros.tipo_novedad"
              class="form-select form-control form-control-sm"
              @change="onTipoNovedadChange"
            >
              <option :value="null">Todos los tipos</option>
              <option
                v-for="tipo in listasForms.tiposNovedad"
                :key="tipo.numeracion"
                :value="tipo.numeracion"
              >
                {{ tipo.descripcion }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1">Subnovedad</label>
            <select
              v-model="filtros.tipo_subnovedad"
              class="form-select form-control form-control-sm"
              :disabled="!filtros.tipo_novedad"
            >
              <option :value="null">Todas las subnovedades</option>
              <option
                v-for="sub in subNovedades"
                :key="sub.numeracion"
                :value="sub.numeracion"
              >
                {{ sub.descripcion }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-3">
            <label class="form-label text-muted small mb-1">Relevancia</label>
            <select
              v-model="filtros.relevancia"
              class="form-select form-control form-control-sm"
            >
              <option :value="null">Todas</option>
              <option
                v-for="rel in listasForms.relevancias"
                :key="rel.numeracion"
                :value="rel.numeracion"
              >
                {{ rel.descripcion }}
              </option>
            </select>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row gap-2 mt-3">
          <button
            @click="cargarNovedades"
            class="btn btn-primary rounded-pill flex-grow-1 shadow-sm"
            :disabled="cargando"
          >
            <i class="fas fa-fire me-2"></i>
            <span v-if="!cargando">Generar Mapa de Calor</span>
            <span v-else>
              <i class="fas fa-spinner fa-spin me-2"></i>
              Cargando...
            </span>
          </button>
          <button
            @click="limpiarFiltros"
            class="btn btn-outline-secondary rounded-pill"
            :disabled="cargando"
          >
            <i class="fas fa-eraser me-2"></i>
            Limpiar
          </button>
        </div>

        <!-- Resumen de resultados -->
        <div v-if="novedades.length > 0" class="mt-3">
          <div
            class="alert alert-info mb-0 d-flex flex-wrap align-items-center gap-2"
          >
            <span class="badge bg-white text-dark border rounded-pill">
              <i class="fas fa-info-circle me-1 text-info"></i>
              {{ novedades.length }} novedades
            </span>
            <span class="badge bg-danger rounded-pill">
              {{ totalPorRelevancia.emergencias }} emergencias
            </span>
            <span class="badge bg-warning text-dark rounded-pill">
              {{ totalPorRelevancia.advertencias }} advertencias
            </span>
            <span class="badge bg-white text-dark border rounded-pill">
              <i class="fas fa-layer-group me-1 text-primary"></i>
              {{ novedadesPorOperacion.length }} tipos
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-2">
      <!-- Mapa -->
      <div class="col-lg-8">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white border-0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <span
                  class="badge bg-primary bg-opacity-10 text-primary border rounded-pill me-2"
                >
                  <i class="fas fa-map-marked-alt me-1"></i>
                  Mapa
                </span>
                <small class="text-muted">
                  {{
                    vehiculoAislado
                      ? "Vehículo: " + vehiculoAislado
                      : operacionAislada
                      ? "Tipo: " + operacionAislada
                      : "Concentración de novedades"
                  }}
                </small>
              </div>
              <span class="badge bg-white text-dark border rounded-pill">
                {{ novedadesVisibles.length }} puntos
              </span>
            </div>
          </div>
          <div class="card-body p-0">
            <div ref="mapaCalor" style="height: 620px; width: 100%"></div>
          </div>

          <!-- Leyenda y controles -->
          <div class="card-footer bg-white border-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <span class="badge bg-light text-dark border rounded-pill">
                <i class="fas fa-fire me-1 text-danger"></i>
                Intensidad
              </span>
              <span class="badge bg-success rounded-pill">Baja</span>
              <div class="gradient-bar mx-1"></div>
              <span class="badge bg-danger rounded-pill">Alta</span>
            </div>

            <!-- Leyenda de marcadores por entidad -->
            <div
              v-if="capasMapa.marcadores"
              class="d-flex align-items-center flex-wrap gap-2 mt-2"
            >
              <span class="badge bg-light text-dark border rounded-pill">
                <i class="fas fa-map-pin me-1 text-secondary"></i>
                Marcadores
              </span>
              <span
                v-for="tipo in tiposEntidad"
                :key="tipo"
                class="badge rounded-pill"
                :class="claseBadgeTipo(tipo)"
              >
                {{ tipo }}
              </span>
            </div>

            <div class="row g-3 mt-2">
              <div class="col-12 col-md-6">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-muted small">Radio de influencia</span>
                  <span class="badge bg-white text-dark border rounded-pill">
                    {{ heatmapConfig.radius }}px
                  </span>
                </div>
                <input
                  v-model="heatmapConfig.radius"
                  type="range"
                  min="10"
                  max="50"
                  class="form-range w-100"
                  @input="actualizarHeatmap"
                />
              </div>
              <div class="col-12 col-md-6">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-muted small">Opacidad</span>
                  <span class="badge bg-white text-dark border rounded-pill">
                    {{ Math.round(heatmapConfig.opacity * 100) }}%
                  </span>
                </div>
                <input
                  v-model="heatmapConfig.opacity"
                  type="range"
                  min="0"
                  max="1"
                  step="0.1"
                  class="form-range w-100"
                  @input="actualizarHeatmap"
                />
              </div>
            </div>

            <div class="d-flex flex-wrap gap-2 mt-3">
              <label
                class="btn btn-outline-secondary btn-sm rounded-pill px-3"
                :class="{ 'btn-secondary text-white': capasMapa.marcadores }"
              >
                <input
                  type="checkbox"
                  class="d-none"
                  v-model="capasMapa.marcadores"
                  @change="dibujarMarcadores"
                />
                <i class="fas fa-map-pin me-1"></i>
                Marcadores
              </label>
              <label
                class="btn btn-outline-info btn-sm rounded-pill px-3"
                :class="{ 'btn-info text-white': capasMapa.rutas }"
              >
                <input
                  type="checkbox"
                  class="d-none"
                  v-model="capasMapa.rutas"
                  @change="toggleRutas"
                  :disabled="capasCargando.rutas"
                />
                <span v-if="capasCargando.rutas">
                  <span
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Cargando...
                </span>
                <span v-else>
                  <i class="fas fa-route me-1"></i>
                  Rutas TIF
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Panel por tipo / vehículos / novedades -->
      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-gradient-navy text-white py-2">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center min-w-0">
                <i class="fas me-2" :class="iconoPanelLateral"></i>
                <h6 class="mb-0 ml-1 text-truncate">
                  {{ tituloPanelLateral }}
                </h6>
              </div>
              <button
                v-if="operacionAislada"
                class="btn btn-sm btn-light rounded-pill flex-shrink-0"
                @click="volverPanelLateral"
              >
                <i class="fas fa-arrow-left me-1"></i>
                Volver
              </button>
            </div>
          </div>
          <div
            class="card-body p-0"
            style="max-height: 780px; overflow-y: auto"
          >
            <!-- Lista de tipos -->
            <template v-if="!operacionAislada">
              <div
                v-if="novedadesPorOperacion.length === 0"
                class="text-center text-muted p-4"
              >
                <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                <small>Genera el mapa para ver los tipos de entidad</small>
              </div>

              <div v-else class="list-group list-group-flush">
                <button
                  v-for="grupo in novedadesPorOperacion"
                  :key="grupo.nombre"
                  type="button"
                  class="list-group-item list-group-item-action"
                  @click="aislarOperacion(grupo.nombre)"
                >
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span class="fw-semibold text-truncate">
                      <span
                        class="badge rounded-pill me-1"
                        :class="grupo.badgeClass"
                      >
                        {{ grupo.nombre }}
                      </span>
                    </span>
                    <span class="badge bg-primary rounded-pill">
                      {{ grupo.total }}
                    </span>
                  </div>
                  <div class="d-flex flex-wrap gap-1">
                    <span
                      v-if="grupo.emergencias > 0"
                      class="badge bg-danger rounded-pill"
                    >
                      <i class="fas fa-exclamation-circle me-1"></i>
                      {{ grupo.emergencias }}
                    </span>
                    <span
                      v-if="grupo.advertencias > 0"
                      class="badge bg-warning text-dark rounded-pill"
                    >
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      {{ grupo.advertencias }}
                    </span>
                    <span class="badge bg-light text-dark border rounded-pill">
                      <i class="fas fa-truck me-1"></i>
                      {{ grupo.vehiculos }} vehículos
                    </span>
                  </div>
                  <div class="progress mt-2" style="height: 6px">
                    <div
                      class="progress-bar"
                      :class="grupo.barraClass"
                      role="progressbar"
                      :style="{ width: grupo.porcentaje + '%' }"
                    ></div>
                  </div>
                  <small class="text-muted">
                    {{ grupo.porcentaje }}% del total
                  </small>
                </button>
              </div>
            </template>

            <!-- Lista de vehículos del tipo seleccionado -->
            <template v-else-if="!vehiculoAislado">
              <div
                v-if="novedadesPorVehiculo.length === 0"
                class="text-center text-muted p-4"
              >
                <i class="fas fa-truck fa-2x mb-2 d-block"></i>
                <small>Sin vehículos para este tipo</small>
              </div>

              <div v-else class="list-group list-group-flush">
                <button
                  v-for="vh in novedadesPorVehiculo"
                  :key="vh.placa"
                  type="button"
                  class="list-group-item list-group-item-action"
                  @click="aislarVehiculo(vh.placa)"
                >
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span class="fw-semibold text-truncate">
                      <i class="fas fa-truck me-1 text-primary"></i>
                      {{ vh.placa }}
                    </span>
                    <span class="badge bg-primary rounded-pill">
                      {{ vh.total }}
                    </span>
                  </div>
                  <div class="d-flex flex-wrap gap-1">
                    <span
                      v-if="vh.emergencias > 0"
                      class="badge bg-danger rounded-pill"
                    >
                      <i class="fas fa-exclamation-circle me-1"></i>
                      {{ vh.emergencias }}
                    </span>
                    <span
                      v-if="vh.advertencias > 0"
                      class="badge bg-warning text-dark rounded-pill"
                    >
                      <i class="fas fa-exclamation-triangle me-1"></i>
                      {{ vh.advertencias }}
                    </span>
                    <span
                      v-if="vh.conductor !== '—'"
                      class="badge bg-light text-dark border rounded-pill text-truncate"
                      style="max-width: 160px"
                    >
                      <i class="fas fa-user me-1"></i>
                      {{ vh.conductor }}
                    </span>
                  </div>
                  <div class="progress mt-2" style="height: 6px">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      :style="{ width: vh.porcentaje + '%' }"
                    ></div>
                  </div>
                  <small class="text-muted">
                    {{ vh.porcentaje }}% del tipo
                  </small>
                </button>
              </div>
            </template>

            <!-- Detalle de novedades del vehículo (misma info del marcador) -->
            <template v-else>
              <div
                v-if="novedadesDelVehiculo.length === 0"
                class="text-center text-muted p-4"
              >
                <i class="fas fa-exclamation-circle fa-2x mb-2 d-block"></i>
                <small>Sin novedades para este vehículo</small>
              </div>

              <div v-else class="p-2 d-flex flex-column gap-2">
                <button
                  v-for="novedad in novedadesDelVehiculo"
                  :key="novedad.id"
                  type="button"
                  class="card border-0 shadow-sm text-start novedad-card"
                  @click="enfocarNovedad(novedad)"
                >
                  <div
                    class="card-header border-0 text-white py-2 px-3"
                    :style="{
                      background:
                        'linear-gradient(135deg, ' +
                        colorTipo(nombreTipoServicio(novedad)) +
                        ' 0%, ' +
                        colorTipo(nombreTipoServicio(novedad)) +
                        'cc 100%)',
                    }"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span class="small fw-semibold text-uppercase">
                        {{ nombreTipoServicio(novedad) }}
                      </span>
                      <span
                        class="badge rounded-pill"
                        style="background: rgba(255,255,255,0.2)"
                      >
                        #{{ novedad.entidad_id || "—" }}
                      </span>
                    </div>
                    <div class="fw-bold mt-1" style="letter-spacing: 0.04em">
                      {{ placaNovedad(novedad) }}
                    </div>
                    <small class="opacity-75">
                      Novedad:
                      {{ formatoFechaCorta(novedad.fecha_novedad) }}
                    </small>
                  </div>

                  <div class="card-body py-2 px-3">
                    <div class="fw-semibold mb-2" style="font-size: 13px">
                      {{ tituloNovedad(novedad) }}
                    </div>

                    <span
                      class="badge rounded-pill mb-2"
                      :style="{
                        color: colorRelevancia(novedad),
                        background: colorRelevancia(novedad) + '14',
                      }"
                    >
                      <span
                        class="d-inline-block rounded-circle me-1"
                        :style="{
                          width: '7px',
                          height: '7px',
                          background: colorRelevancia(novedad),
                        }"
                      ></span>
                      {{ novedad.nRelevancia || "Sin relevancia" }}
                    </span>

                    <div class="novedad-detalle">
                      <div class="fila-detalle">
                        <span>Fecha inicial</span>
                        <strong>{{ fechaInicialEntidad(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Fecha final</span>
                        <strong>{{ fechaFinalEntidad(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Usuario</span>
                        <strong>{{ nombreUsuario(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Origen</span>
                        <strong>{{ origenEntidad(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Destino</span>
                        <strong>{{ destinoEntidad(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Velocidad</span>
                        <strong>{{ velocidadNovedad(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Conductor</span>
                        <strong>{{ nombreConductor(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Empresa</span>
                        <strong>{{ nombreEmpresa(novedad) }}</strong>
                      </div>
                      <div class="fila-detalle">
                        <span>Bloque</span>
                        <strong>{{ bloqueEntidad(novedad) }}</strong>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import "vue-select/dist/vue-select.css";
import Loading from "@/components/Loading";
import { crearMapaCalor } from "@/utils/mapaCalorOverlay";

// Se asigna cuando la API de Google Maps termina de cargar, no al evaluar el módulo
let google = null;

export default {
  name: "MapaCalorNovedadesTif",
  components: {
    Loading,
  },
  data() {
    return {
      cargando: false,
      hoy: moment().format("YYYY-MM-DD"),
      filtros: {
        fecha_inicial: moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        fecha_final: moment().format("YYYY-MM-DD"),
        operacion_id: null,
        tipo_servicio: null,
        tipo_novedad: null,
        tipo_subnovedad: null,
        relevancia: null,
      },
      novedades: [],
      operacionAislada: null,
      vehiculoAislado: null,
      mapa: null,
      heatmap: null,
      marcadores: [],
      infoWindow: null,
      heatmapConfig: {
        radius: 25,
        opacity: 0.6,
      },
      capasMapa: {
        marcadores: false,
        rutas: false,
      },
      capasCargando: {
        rutas: false,
      },
      polilineas: [],
      listasForms: {
        operaciones: [],
        tiposNovedad: [],
        relevancias: [],
        subNovedadesGps: [],
        subNovedadesRutas: [],
        subNovedadesGeocercas: [],
      },
    };
  },
  computed: {
    subNovedades() {
      switch (this.filtros.tipo_novedad) {
        case 1:
          return this.listasForms.subNovedadesGps;
        case 2:
          return this.listasForms.subNovedadesRutas;
        case 3:
          return [];
        default:
          return this.listasForms.subNovedadesGeocercas;
      }
    },

    tiposEntidad() {
      return this.novedadesPorOperacion.map((grupo) => grupo.nombre);
    },

    tituloPanelLateral() {
      if (this.vehiculoAislado) {
        return "Novedades · " + this.vehiculoAislado;
      }
      if (this.operacionAislada) {
        return "Vehículos · " + this.operacionAislada;
      }
      return "Novedades por Tipo";
    },

    iconoPanelLateral() {
      if (this.vehiculoAislado) return "fa-exclamation-circle";
      if (this.operacionAislada) return "fa-truck";
      return "fa-layer-group";
    },

    novedadesVisibles() {
      let lista = this.novedades;

      if (this.operacionAislada) {
        lista = lista.filter(
          (novedad) =>
            this.nombreTipoServicio(novedad) === this.operacionAislada,
        );
      }

      if (this.vehiculoAislado) {
        lista = lista.filter(
          (novedad) => this.placaNovedad(novedad) === this.vehiculoAislado,
        );
      }

      return lista;
    },

    totalPorRelevancia() {
      return this.novedades.reduce(
        (acc, novedad) => {
          if (novedad.relevancia == 2) acc.emergencias++;
          else if (novedad.relevancia == 1) acc.advertencias++;
          return acc;
        },
        { emergencias: 0, advertencias: 0 },
      );
    },

    novedadesPorOperacion() {
      const grupos = {};

      this.novedades.forEach((novedad) => {
        const nombre = this.nombreTipoServicio(novedad);

        if (!grupos[nombre]) {
          grupos[nombre] = {
            nombre,
            total: 0,
            emergencias: 0,
            advertencias: 0,
            placas: new Set(),
          };
        }

        grupos[nombre].total++;
        if (novedad.relevancia == 2) grupos[nombre].emergencias++;
        else if (novedad.relevancia == 1) grupos[nombre].advertencias++;
        if (novedad.vehiculo && novedad.vehiculo.placa) {
          grupos[nombre].placas.add(novedad.vehiculo.placa);
        }
      });

      const total = this.novedades.length || 1;
      const orden = {
        "Tep Viajes": 1,
        "Tif Turno": 2,
        "Tep Turno": 3,
        "Planta Externa Viaje": 4,
      };

      return Object.values(grupos)
        .map((grupo) => ({
          nombre: grupo.nombre,
          total: grupo.total,
          emergencias: grupo.emergencias,
          advertencias: grupo.advertencias,
          vehiculos: grupo.placas.size,
          porcentaje: Math.round((grupo.total / total) * 100),
          badgeClass: this.claseBadgeTipo(grupo.nombre),
          barraClass: this.claseBarraTipo(grupo.nombre),
        }))
        .sort((a, b) => (orden[a.nombre] || 99) - (orden[b.nombre] || 99));
    },

    // Agrupa las novedades del tipo seleccionado por placa de vehículo
    novedadesPorVehiculo() {
      if (!this.operacionAislada) return [];

      const grupos = {};
      const delTipo = this.novedades.filter(
        (novedad) => this.nombreTipoServicio(novedad) === this.operacionAislada,
      );

      delTipo.forEach((novedad) => {
        const placa = this.placaNovedad(novedad);

        if (!grupos[placa]) {
          grupos[placa] = {
            placa,
            total: 0,
            emergencias: 0,
            advertencias: 0,
            conductor: this.nombreConductor(novedad),
          };
        }

        grupos[placa].total++;
        if (novedad.relevancia == 2) grupos[placa].emergencias++;
        else if (novedad.relevancia == 1) grupos[placa].advertencias++;
        if (grupos[placa].conductor === "—") {
          grupos[placa].conductor = this.nombreConductor(novedad);
        }
      });

      const total = delTipo.length || 1;

      return Object.values(grupos)
        .map((grupo) => ({
          ...grupo,
          porcentaje: Math.round((grupo.total / total) * 100),
        }))
        .sort((a, b) => b.total - a.total);
    },

    novedadesDelVehiculo() {
      if (!this.vehiculoAislado) return [];
      return this.novedadesVisibles
        .slice()
        .sort(
          (a, b) =>
            moment(b.fecha_novedad).valueOf() -
            moment(a.fecha_novedad).valueOf(),
        );
    },
  },
  async mounted() {
    // Las listas se cargan antes que las novedades para no saturar el backend
    await this.cargarListas();
    this.esperarGoogleMaps();
  },
  beforeDestroy() {
    this.limpiarMarcadores();
    this.limpiarRutas();
    if (this.heatmap) {
      this.heatmap.setMap(null);
    }
    this.mapa = null;
  },
  methods: {
    async esperarGoogleMaps() {
      // Dispara la carga de la API si aún no ha empezado
      if (this.$gmapApiPromiseLazy) {
        await this.$gmapApiPromiseLazy();
      }

      await new Promise((resolve) => {
        const verificar = () => {
          if (window.google?.maps?.OverlayView) {
            resolve();
          } else {
            setTimeout(verificar, 100);
          }
        };
        verificar();
      });

      google = window.google;
      this.inicializarMapa();
      this.cargarNovedades();
    },

    inicializarMapa() {
      this.mapa = new google.maps.Map(this.$refs.mapaCalor, {
        center: { lat: 4.570868, lng: -74.297333 },
        zoom: 6,
        mapTypeId: "roadmap",
        mapTypeControl: true,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true,
      });
      this.infoWindow = new google.maps.InfoWindow({
        maxWidth: 320,
        pixelOffset: new google.maps.Size(0, -8),
      });
    },

    async cargarListas() {
      try {
        const [
          operacionesResponse,
          tiposResponse,
          relevanciasResponse,
          subNovedadesGpsResponse,
          subNovedadesRutasResponse,
          subNovedadesGeocercasResponse,
        ] = await Promise.all([
          axios.get("/api/lista/157"),
          axios.get("/api/lista/149"),
          axios.get("/api/lista/158"),
          axios.get("/api/lista/159"),
          axios.get("/api/lista/225"),
        ]);
        this.listasForms.tiposNovedad = tiposResponse.data;
        this.listasForms.relevancias = relevanciasResponse.data;
        this.listasForms.subNovedadesGps = subNovedadesGpsResponse.data;
        this.listasForms.subNovedadesRutas = subNovedadesRutasResponse.data;
        this.listasForms.subNovedadesGeocercas =
          subNovedadesGeocercasResponse.data;
      } catch (error) {
        // Las listas se cargan de forma silenciosa
      }
    },

    onTipoNovedadChange() {
      this.filtros.tipo_subnovedad = null;
    },

    async cargarNovedades() {
      if (!this.filtros.fecha_inicial || !this.filtros.fecha_final) {
        this.$swal({
          icon: "warning",
          title: "Atención",
          text: "Debe seleccionar el rango de fechas",
        });
        return;
      }

      this.cargando = true;
      try {
        const response = await axios.get(
          "/api/tif/centralTrafico/novedadesMapaCalor",
          { params: this.filtros },
        );

        this.novedades = response.data.data || [];
        this.operacionAislada = null;
        this.vehiculoAislado = null;

        if (this.novedades.length === 0) {
          this.$swal({
            icon: "info",
            title: "Sin resultados",
            text: "No se encontraron novedades con los filtros seleccionados",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        const respuesta = error.response;
        const detalle = respuesta
          ? respuesta.status + ": " + (respuesta.data.message || error.message)
          : error.message;

        this.$swal({
          icon: "error",
          title: "Error al cargar el mapa de calor",
          text: detalle,
        });
      } finally {
        this.cargando = false;
      }

      this.generarMapaCalor();
    },

    nombreOperacion(novedad) {
      return novedad.nOperacion || "Sin operación";
    },

    // Etiqueta según entidad_type (igual que en gestión de novedades)
    nombreTipoServicio(novedad) {
      switch (novedad.entidad_type) {
        case "App\\TepViajes":
          return "Tep Viajes";
        case "App\\TifTurnos":
          return "Tif Turno";
        case "App\\TepTurno":
          return "Tep Turno";
        case "App\\PlantViaje":
          return "Planta Externa Viaje";
        default:
          return "N/A";
      }
    },

    claseBadgeTipo(nombre) {
      switch (nombre) {
        case "Tep Viajes":
          return "bg-primary";
        case "Tif Turno":
          return "bg-success";
        case "Tep Turno":
          return "bg-info";
        case "Planta Externa Viaje":
          return "bg-navy";
        default:
          return "bg-secondary";
      }
    },

    colorTipo(nombre) {
      switch (nombre) {
        case "Tep Viajes":
          return "#0d6efd";
        case "Tif Turno":
          return "#198754";
        case "Tep Turno":
          return "#0dcaf0";
        case "Planta Externa Viaje":
          return "#001f3f";
        default:
          return "#6c757d";
      }
    },

    claseBarraTipo(nombre) {
      switch (nombre) {
        case "Tep Viajes":
          return "bg-primary";
        case "Tif Turno":
          return "bg-success";
        case "Tep Turno":
          return "bg-info";
        case "Planta Externa Viaje":
          return "bg-dark";
        default:
          return "bg-secondary";
      }
    },

    pesoNovedad(novedad) {
      if (novedad.relevancia == 2) return 10;
      if (novedad.relevancia == 1) return 5;
      return 3;
    },

    generarMapaCalor() {
      if (!this.mapa) return;

      if (this.heatmap) {
        this.heatmap.setMap(null);
      }

      const puntos = [];
      const bounds = new google.maps.LatLngBounds();

      this.novedadesVisibles.forEach((novedad) => {
        const lat = parseFloat(novedad.latitud);
        const lng = parseFloat(novedad.longitud);

        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const location = new google.maps.LatLng(lat, lng);
        puntos.push({ location, weight: this.pesoNovedad(novedad) });
        bounds.extend(location);
      });

      if (puntos.length > 0) {
        this.heatmap = crearMapaCalor(google, {
          data: puntos,
          map: this.mapa,
          radius: parseInt(this.heatmapConfig.radius),
          opacity: parseFloat(this.heatmapConfig.opacity),
          gradient: [
            "rgba(0, 255, 0, 0)",
            "rgba(0, 255, 0, 1)",
            "rgba(85, 255, 0, 1)",
            "rgba(170, 255, 0, 1)",
            "rgba(255, 255, 0, 1)",
            "rgba(255, 213, 0, 1)",
            "rgba(255, 170, 0, 1)",
            "rgba(255, 128, 0, 1)",
            "rgba(255, 85, 0, 1)",
            "rgba(255, 43, 0, 1)",
            "rgba(255, 0, 0, 1)",
          ],
        });

        this.mapa.fitBounds(bounds);
        if (puntos.length === 1) {
          this.mapa.setZoom(12);
        }
      } else {
        this.mapa.setCenter({ lat: 4.570868, lng: -74.297333 });
        this.mapa.setZoom(6);
      }

      this.dibujarMarcadores();
    },

    actualizarHeatmap() {
      if (this.heatmap) {
        this.heatmap.setOptions({
          radius: parseInt(this.heatmapConfig.radius),
          opacity: parseFloat(this.heatmapConfig.opacity),
        });
      }
    },

    aislarOperacion(nombre) {
      this.operacionAislada = nombre;
      this.vehiculoAislado = null;
      this.generarMapaCalor();
    },

    aislarVehiculo(placa) {
      this.vehiculoAislado = placa;
      this.generarMapaCalor();
    },

    volverPanelLateral() {
      if (this.vehiculoAislado) {
        this.vehiculoAislado = null;
        this.generarMapaCalor();
        return;
      }
      this.verTodasOperaciones();
    },

    verTodasOperaciones() {
      this.operacionAislada = null;
      this.vehiculoAislado = null;
      this.generarMapaCalor();
    },

    placaNovedad(novedad) {
      return (
        (novedad.vehiculo && novedad.vehiculo.placa) ||
        (novedad.entidad &&
          novedad.entidad.vehiculo &&
          novedad.entidad.vehiculo.placa) ||
        "Sin placa"
      );
    },

    tituloNovedad(novedad) {
      return (
        [
          novedad.nTipoNovedad,
          novedad.nSubNovedadGps ||
            novedad.nSubNovedadRuta ||
            novedad.nSubNovedadGeocerca ||
            "",
        ]
          .filter(Boolean)
          .join(" · ") || "Sin detalle de novedad"
      );
    },

    colorRelevancia(novedad) {
      if (novedad.relevancia == 2) return "#dc3545";
      if (novedad.relevancia == 1) return "#f59e0b";
      return "#64748b";
    },

    enfocarNovedad(novedad) {
      if (!this.mapa) return;

      const lat = parseFloat(novedad.latitud);
      const lng = parseFloat(novedad.longitud);
      if (Number.isNaN(lat) || Number.isNaN(lng)) return;

      this.mapa.setCenter({ lat, lng });
      this.mapa.setZoom(Math.max(this.mapa.getZoom() || 0, 14));

      if (!this.infoWindow) {
        this.infoWindow = new google.maps.InfoWindow({
          maxWidth: 320,
          pixelOffset: new google.maps.Size(0, -8),
        });
      }

      this.infoWindow.setContent(this.contenidoInfoWindow(novedad));
      this.infoWindow.setPosition({ lat, lng });
      this.infoWindow.open(this.mapa);
    },

    limpiarMarcadores() {
      this.marcadores.forEach((marcador) => marcador.setMap(null));
      this.marcadores = [];
    },

    dibujarMarcadores() {
      this.limpiarMarcadores();

      if (!this.capasMapa.marcadores || !this.mapa) return;

      this.novedadesVisibles.forEach((novedad) => {
        const lat = parseFloat(novedad.latitud);
        const lng = parseFloat(novedad.longitud);

        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const marcador = new google.maps.Marker({
          position: { lat, lng },
          map: this.mapa,
          title: this.nombreTipoServicio(novedad),
          icon: this.iconoMarcador(novedad),
        });

        marcador.addListener("click", () => {
          this.infoWindow.setContent(this.contenidoInfoWindow(novedad));
          this.infoWindow.setPosition({ lat, lng });
          this.infoWindow.open(this.mapa);
        });

        this.marcadores.push(marcador);
      });
    },

    // El relleno identifica la entidad y el borde resalta la relevancia
    iconoMarcador(novedad) {
      const bordes = {
        1: "#ffc107",
        2: "#dc3545",
      };

      return {
        path:
          "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: this.colorTipo(this.nombreTipoServicio(novedad)),
        fillOpacity: 1,
        strokeColor: bordes[novedad.relevancia] || "#ffffff",
        strokeWeight: bordes[novedad.relevancia] ? 3 : 2,
        scale: 1.3,
        anchor: new google.maps.Point(12, 24),
      };
    },

    formatoFechaCorta(valor) {
      if (!valor) return "—";
      const fecha = moment(valor);
      return fecha.isValid() ? fecha.format("DD/MM/YYYY HH:mm") : String(valor);
    },

    nombreConductor(novedad) {
      const conductor =
        (novedad.conductor && novedad.conductor.nombres
          ? novedad.conductor
          : null) ||
        (novedad.entidad && novedad.entidad.conductor) ||
        null;

      if (!conductor) return "—";
      return (
        [conductor.nombres, conductor.apellidos].filter(Boolean).join(" ") ||
        "—"
      );
    },

    nombreEmpresa(novedad) {
      return (
        (novedad.empresa && novedad.empresa.razon_social) ||
        (novedad.entidad &&
          novedad.entidad.empresa &&
          novedad.entidad.empresa.razon_social) ||
        (novedad.entidad &&
          novedad.entidad.transportadora &&
          novedad.entidad.transportadora.razon_social) ||
        "—"
      );
    },

    nombreUsuario(novedad) {
      const entidad = novedad.entidad || {};
      return (
        (entidad.user && entidad.user.name) ||
        (entidad.solicitudes &&
          entidad.solicitudes.user &&
          entidad.solicitudes.user.name) ||
        "—"
      );
    },

    fechaInicialEntidad(novedad) {
      const entidad = novedad.entidad || {};
      return this.formatoFechaCorta(
        entidad.fecha_ini || entidad.fecha_inicial || entidad.fecha,
      );
    },

    fechaFinalEntidad(novedad) {
      const entidad = novedad.entidad || {};
      return this.formatoFechaCorta(entidad.fecha_fin || entidad.fecha_final);
    },

    origenEntidad(novedad) {
      const entidad = novedad.entidad || {};
      return (
        entidad.direccion_origen ||
        (entidad.sitio_cargue && entidad.sitio_cargue.nombre) ||
        (entidad.sitioCargue && entidad.sitioCargue.nombre) ||
        (entidad.sitio && entidad.sitio.nombre) ||
        (entidad.ruta && entidad.ruta.origen && entidad.ruta.origen.nombre) ||
        (entidad.ruta && entidad.ruta.nombre) ||
        "—"
      );
    },

    destinoEntidad(novedad) {
      const entidad = novedad.entidad || {};
      return (
        entidad.direccion_destino ||
        (entidad.sitio_descargue && entidad.sitio_descargue.nombre) ||
        (entidad.sitioDescargue && entidad.sitioDescargue.nombre) ||
        (entidad.ruta && entidad.ruta.destino && entidad.ruta.destino.nombre) ||
        "—"
      );
    },

    bloqueEntidad(novedad) {
      const entidad = novedad.entidad || {};
      return (
        (entidad.bloque && entidad.bloque.nombre) ||
        (entidad.sitio && entidad.sitio.bloque && entidad.sitio.bloque.nombre) ||
        "—"
      );
    },

    velocidadNovedad(novedad) {
      if (novedad.velocidad == null || novedad.velocidad === "") return "—";
      return `${novedad.velocidad} km/h`;
    },

    filaInfo(etiqueta, valor) {
      return `
        <div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">
          <span style="color:#64748b;flex-shrink:0;">${etiqueta}</span>
          <span style="font-weight:600;text-align:right;word-break:break-word;">${valor || "—"}</span>
        </div>
      `;
    },

    contenidoInfoWindow(novedad) {
      const placa = novedad.vehiculo ? novedad.vehiculo.placa : "Sin vehículo";
      const subNovedad =
        novedad.nSubNovedadGps ||
        novedad.nSubNovedadRuta ||
        novedad.nSubNovedadGeocerca ||
        "";
      const tipo = this.nombreTipoServicio(novedad);
      const color = this.colorTipo(tipo);
      const relevancia = novedad.nRelevancia || "Sin relevancia";
      const tituloNovedad = [novedad.nTipoNovedad, subNovedad]
        .filter(Boolean)
        .join(" · ");
      const colorRelevancia =
        novedad.relevancia == 2
          ? "#dc3545"
          : novedad.relevancia == 1
          ? "#f59e0b"
          : "#64748b";

      const filas = [
        this.filaInfo("Fecha inicial", this.fechaInicialEntidad(novedad)),
        this.filaInfo("Fecha final", this.fechaFinalEntidad(novedad)),
        this.filaInfo("Usuario", this.nombreUsuario(novedad)),
        this.filaInfo("Origen", this.origenEntidad(novedad)),
        this.filaInfo("Destino", this.destinoEntidad(novedad)),
        this.filaInfo("Velocidad", this.velocidadNovedad(novedad)),
        this.filaInfo("Conductor", this.nombreConductor(novedad)),
        this.filaInfo("Empresa", this.nombreEmpresa(novedad)),
        this.filaInfo("Bloque", this.bloqueEntidad(novedad)),
      ].join("");

      return `
        <div style="
          font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
          width: 300px;
          color: #0f172a;
          line-height: 1.35;
        ">
          <div style="
            background: linear-gradient(135deg, ${color} 0%, ${color}cc 100%);
            color: #fff;
            border-radius: 12px 12px 0 0;
            padding: 12px 14px;
          ">
            <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 8px;
              margin-bottom: 6px;
            ">
              <span style="
                font-size: 11px;
                font-weight: 600;
                letter-spacing: 0.03em;
                text-transform: uppercase;
                opacity: 0.92;
              ">${tipo}</span>
              <span style="
                font-size: 11px;
                background: rgba(255,255,255,0.2);
                padding: 2px 8px;
                border-radius: 999px;
              ">#${novedad.entidad_id || "—"}</span>
            </div>
            <div style="
              font-size: 18px;
              font-weight: 700;
              letter-spacing: 0.04em;
            ">${placa}</div>
            <div style="
              margin-top: 6px;
              font-size: 11px;
              opacity: 0.9;
            ">
              Novedad: ${this.formatoFechaCorta(novedad.fecha_novedad)}
            </div>
          </div>

          <div style="
            background: #fff;
            border: 1px solid #e2e8f0;
            border-top: 0;
            border-radius: 0 0 12px 12px;
            padding: 12px 14px;
          ">
            <div style="
              font-size: 13px;
              font-weight: 600;
              color: #1e293b;
              margin-bottom: 8px;
            ">
              ${tituloNovedad || "Sin detalle de novedad"}
            </div>

            <div style="
              display: inline-flex;
              align-items: center;
              gap: 5px;
              font-size: 11px;
              font-weight: 600;
              color: ${colorRelevancia};
              background: ${colorRelevancia}14;
              border-radius: 999px;
              padding: 3px 8px;
              margin-bottom: 10px;
            ">
              <span style="
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background: ${colorRelevancia};
                display: inline-block;
              "></span>
              ${relevancia}
            </div>

            <div style="display: grid; gap: 8px; font-size: 12px;">
              ${filas}
            </div>
          </div>
        </div>
      `;
    },

    toggleRutas() {
      if (this.capasMapa.rutas) {
        this.cargarRutas();
      } else {
        this.limpiarRutas();
      }
    },

    limpiarRutas() {
      this.polilineas.forEach((polilinea) => polilinea.setMap(null));
      this.polilineas = [];
    },

    async cargarRutas() {
      if (!this.mapa) return;

      this.capasCargando.rutas = true;
      try {
        const response = await axios.get(
          "/api/admin/centralTrafico/rutasTramosMapaCalor",
        );
        this.dibujarRutas(response.data.data || []);
      } catch (error) {
        this.capasMapa.rutas = false;
      } finally {
        this.capasCargando.rutas = false;
      }
    },

    dibujarRutas(rutas) {
      this.limpiarRutas();

      rutas.forEach((ruta) => {
        (ruta.rutas_tramos || []).forEach((rutaTramo) => {
          const tramo = rutaTramo.tramo_ruta;
          if (!tramo || !tramo.det_tramos_rutas) return;

          const detalles = [...tramo.det_tramos_rutas].sort(
            (a, b) => (a.orden || 0) - (b.orden || 0),
          );

          const path = [];
          detalles.forEach((detalle, index) => {
            const latIni = parseFloat(detalle.lat_ini);
            const lngIni = parseFloat(detalle.lon_ini);
            const latFin = parseFloat(detalle.lat_fin);
            const lngFin = parseFloat(detalle.lon_fin);

            if (
              Number.isNaN(latIni) ||
              Number.isNaN(lngIni) ||
              Number.isNaN(latFin) ||
              Number.isNaN(lngFin)
            ) {
              return;
            }

            if (index === 0) path.push({ lat: latIni, lng: lngIni });
            path.push({ lat: latFin, lng: lngFin });
          });

          if (path.length < 2) return;

          this.polilineas.push(
            new google.maps.Polyline({
              path,
              strokeColor: tramo.color || "#2563eb",
              strokeOpacity: 0.7,
              strokeWeight: 4,
              map: this.mapa,
            }),
          );
        });
      });
    },

    limpiarFiltros() {
      this.filtros = {
        fecha_inicial: moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        fecha_final: moment().format("YYYY-MM-DD"),
        operacion_id: null,
        tipo_servicio: null,
        tipo_novedad: null,
        tipo_subnovedad: null,
        relevancia: null,
      };
      this.novedades = [];
      this.operacionAislada = null;
      this.vehiculoAislado = null;

      this.limpiarMarcadores();
      if (this.heatmap) {
        this.heatmap.setMap(null);
      }
      if (this.mapa) {
        this.mapa.setCenter({ lat: 4.570868, lng: -74.297333 });
        this.mapa.setZoom(6);
      }
    },
  },
};
</script>

<style scoped>
.gradient-bar {
  width: 100px;
  height: 20px;
  background: linear-gradient(to right, #00ff00, #ffff00, #ff0000);
  border-radius: 4px;
  border: 1px solid #ddd;
}

.form-range {
  cursor: pointer;
}

.alert-info {
  border-left: 4px solid #17a2b8;
}

.list-group-item-action {
  cursor: pointer;
}

.bg-navy {
  background-color: #001f3f !important;
  color: #fff;
}

.novedad-card {
  cursor: pointer;
  overflow: hidden;
  border-radius: 12px !important;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.novedad-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12) !important;
}

.novedad-detalle {
  display: grid;
  gap: 6px;
  font-size: 12px;
}

.fila-detalle {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: flex-start;
}

.fila-detalle > span {
  color: #64748b;
  flex-shrink: 0;
}

.fila-detalle > strong {
  text-align: right;
  word-break: break-word;
  font-weight: 600;
  color: #0f172a;
}
</style>

<style>
/* Limpia el chrome nativo del InfoWindow de Google Maps */
.mapa-calor-tif .gm-style .gm-style-iw-c {
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden !important;
}

.mapa-calor-tif .gm-style .gm-style-iw-d {
  overflow: hidden !important;
  padding: 0 !important;
}

.mapa-calor-tif .gm-style .gm-style-iw-tc::after {
  background: linear-gradient(135deg, #0d6efd, #0d6efdcc);
}

.mapa-calor-tif .gm-ui-hover-effect {
  top: 4px !important;
  right: 4px !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.2) !important;
}

.mapa-calor-tif .gm-ui-hover-effect > span {
  background-color: #fff !important;
}
</style>
